import { API_ENDPOINTS } from "../../constants/endpoints";
import { get, post, put, del } from "../../utils/api.utils";

interface ApiResponse {
    statusCode: number;
    message: string;
    [key: string]: any;
}
interface LeadSquaredResponse {
    data: string; // The lead ID is a string
    timestamp: string;
    status: number;
}

export class LeadsquaredService {

    public static async createtLead(leadData: any, phone: string, utm_Data: any) {
        try {
            const leadPayload = {
                "EmailAddress": leadData.email,
                "FirstName": leadData.firstName,
                "LastName": leadData.lastName,
                "Phone": phone
            }
            if(utm_Data){
                (leadPayload as any).utm_source = utm_Data.utm_source;
                (leadPayload as any).utm_medium = utm_Data.utm_medium; 
                (leadPayload as any).utm_campaign = utm_Data.utm_campaign;
                (leadPayload as any).utm_content = utm_Data.utm_content;
                (leadPayload as any).utm_term = utm_Data.utm_term;
            }
            const response = await post(API_ENDPOINTS.LEAD_SQUARED.CREATE_LEADS, leadPayload) as ApiResponse;
            if (response.status !== 201) {
                console.warn("Lead already exists", response.message);
            }
            return response.data.Message.Id;
        } catch (error) {
            console.error("Error creating lead:", error);
        }

    }

    public static async joinActivity(leadData: any) {
        const userId = localStorage.getItem("userId");
        const leadPayload = {
            "prospectId": leadData.id,
            "activityEvent": leadData.activityEvent,
            "activityValue": leadData.activityValue,
            "activityNote": leadData.activityNote
        }

        try {
            const response = await post(API_ENDPOINTS.LEAD_SQUARED.JOIN_ACTIVITY, leadPayload);
            return response;
        } catch (error: any) {
            throw error.response?.data || error;
        }
    }

    public static async getLeadsByEmail(email: string) {
        const response = await get(API_ENDPOINTS.LEAD_SQUARED.GET_LEADS_BY_EMAIL + email) as LeadSquaredResponse;
        return response.data;
    }

    public static async updateLsField(leadData: any) {
        const response = await post(API_ENDPOINTS.LEAD_SQUARED.UPDATE_LS_FIELD, leadData);
        return response;
    }
}
